<!--屹城询价单定制模板-->
<template>
    <div v-loading="loading" style="min-height: 400px">
        <div id="printContent" style="color: #000">
            <div :key="index" v-for="(item, index) in printList">
                <div class="print-title">供应商询价单</div>
                <div class="company">单位：{{ company }}</div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%">客户名称</div>
                        <div class="div-table-cell" style="width: 84%">{{ item.EntpCusName }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%">联系电话</div>
                        <div class="div-table-cell" style="width: 84%"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell time-bottom" style="width: 16%">期限日期</div>
                        <div class="div-table-cell time-bottom" style="width: 84%">{{ item.NeedTime }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell width1" style="width: 20%">汽配编码</div>
                        <div class="div-table-cell" style="width: 10%">互换码</div>
                        <div class="div-table-cell" style="width: 10%">配件名称</div>
                        <div class="div-table-cell" style="width: 23%">车型</div>
                        <div class="div-table-cell" style="width: 5%">单位</div>
                        <div class="div-table-cell" style="width: 6%">数量</div>
                        <div class="div-table-cell" style="width: 8%">品牌</div>
                        <div class="div-table-cell" style="width: 8%">报价价格</div>
                        <div class="div-table-cell" style="width: 10%">备注</div>
                    </div>
                    <div :key="index" class="div-table-row" v-for="(AP, index) in item.DetailList">
                        <div class="div-table-cell-APcode" style="width: 20%">{{ AP.APCode }}</div>
                        <div class="div-table-cell-APcode" style="width: 10%">{{ AP.GoodCode }}</div>
                        <div class="div-table-cell textnowrap" style="width: 10%">{{ AP.GoodName }}</div>
                        <div class="div-table-cell textnowrap" style="width: 23%">{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell" style="width: 5%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Count }}</div>
                        <div class="div-table-cell textnowrap" style="width: 8%">{{ AP.Brand }}</div>
                        <div class="div-table-cell" style="width: 8%">{{ AP.MarketPrice }}</div>
                        <div class="div-table-cell" style="width: 10%">{{ AP.Remark }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell width1" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 10%"></div>
                        <div class="div-table-cell" style="width: 10%"></div>
                        <div class="div-table-cell" style="width: 23%"></div>
                        <div class="div-table-cell" style="width: 5%;text-align: center;">合计</div>
                        <div class="div-table-cell" style="width: 6%">{{ allNum }}</div>
                        <div class="div-table-cell time-bottom" style="width: 8%;text-align: center;">总价</div>
                        <div class="div-table-cell time-bottom" style="width: 8%">{{ allPrice }}</div>
                        <div class="div-table-cell" style="width: 10%"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">客户要求</div>
                        <div class="div-table-cell" style="width: 80%">{{ item.Remark }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
            <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
            <el-button @click="cancel()">关闭</el-button>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
export default {
    name: '',
    components: {},
    props: ['printIds'],
    data() {
        return {
            loading: false,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: this.$util.getLocalStorage('userMsg').EntpName,
            isPrint: false,
            isPreview: false,
            isDefaultSet: false
        };
    },
    created() {
        this.getConfigByCodes();
    },
    mounted() {
        this.getBJOrder();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['dyyl', 'syllqdysz'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'dyyl':
                                this.isPreview = result;
                                break;
                            case 'syllqdysz':
                                this.isDefaultSet = result;
                                break;
                        }
                    }
                }
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
                .company {
                padding: 20px 0;
                }
                .print-title {
                text-align: center;
                font-size: 20px;
                font-weight: bold;
                }
                .dialog-footer {
                text-align: right;
                }
                .print-table-main {
                width: 762px;
                margin-bottom: 20px;
                font-size: 12px;
                } 
                .textnowrap{
                    overflow: hidden !important;
                    text-overflow:clip !important;
                    white-space: nowrap !important;
                }
                .div-table-row {
                    display: flex;
                    margin: 0;
                    font-size: 14px;
                    border-left: 1px dashed #000;
                }
                .div-table-cell-APcode {
                    overflow:hidden;
                    word-break:break-all;
                    white-space: normal;
                    height: auto;
                    line-height: 30px;
                    padding-left: 10px;
                    border-top: 1px dashed #000;
                    border-right: 1px dashed #000;
                    border-bottom: 1px dashed #000;
                    color: #000;
                }
                .div-table-cell {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    height: auto;
                    word-wrap: break-word;
                    word-break: break-all;
                    height: auto;
                    line-height: 24px;
                    padding-left: 3px;
                    border-top: 1px dashed #000;
                    border-right: 1px dashed #000;
                    border-bottom: 1px dashed #000;
                }
                .width1{
                    width:20.8% !important;
                }
                .width2{
                    width:43.5% !important;
                }
                </style>`;
                //width1和width2因为lodop边框会漂移另外调
                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';
                if (this.printList[0].DetailList.length <= 60) {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '93.1mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM(0, 0, '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '93.1mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printIds[0],
                        Type: 14
                    },
                    true
                )
                .then(res => {
                    this.isPrint = true;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        getBJOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetEntpPurInquiryPrint',
                    data: {
                        InquiryId: this.printIds[0]
                    },
                    hideLoading: true
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].MarketPrice;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice.toFixed(2);
                    this.printList.push(res.data);
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.company {
    padding: 20px 0;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
}
.dialog-footer {
    text-align: right;
}
.textnowrap{
    overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow:clip !important;

}
.print-table-main {
    margin-bottom: 20px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
        border-left: 1px dashed #000;

    }
    .div-table-cell-APcode {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: none;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px dashed #000;
        border-right: 1px dashed #000;
        border-bottom: 1px dashed #000;
        color: #000;
    }
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        border-color: black;
        word-wrap: break-word;
        word-break: break-all;
        height: auto;
        line-height: 24px;
        padding-left: 10px;
        border-top: 1px dashed #000;
        border-right: 1px dashed #000;
        border-bottom: 1px dashed #000;
    }
    .time-bottom{
        border-bottom :none
    }
}
</style>
